import { UpdateStorefrontStatusRequest } from "@quickcommerceltd/zone";
import { getCallable } from "../../../firebase/helpers/getCallable";

export const updateStorefrontStatusCallable = getCallable<
  UpdateStorefrontStatusRequest,
  void
>("api-storefront-status");
